/**
 * AvatarBadge — renders a user's uploaded avatar image when present, otherwise
 * the initials badge. Keeps the existing `.ilk-avatar*` sizing/colour classes so
 * it's a drop-in for the old `<span className="ilk-avatar …">{initials}</span>`.
 */
type AvatarUser = { initials: string; avatarUrl?: string | null };

export function AvatarBadge({ user, className }: { user: AvatarUser; className: string }) {
  if (user.avatarUrl) {
    return (
      <img
        className={`${className} ilk-avatar-img`}
        src={user.avatarUrl}
        alt=""
        draggable={false}
      />
    );
  }
  return <span className={className}>{user.initials}</span>;
}
